// @flow
import * as React from 'react';
import { Helmet } from 'react-helmet';

import styles from './CommonPageTemplate.module.scss';;


// DEPRECATED

type Props = {
  title: string,
  header: string,
  children: any,
  headerRightContent: React.Node,
};

const CommonPageTemplateE = ({ title, header, children, headerRightContent }: Props) => (<div>
  <Helmet>
    <title>{title}</title>
  </Helmet>

  <div className={styles.headerContainer}>
    <h1>{header}</h1>
    {headerRightContent}
  </div>

  {children}
</div>);

export default CommonPageTemplateE;
